<template>
    <b-container fluid>
        <b-card v-for="order in ordersArray"  :key="'buyercard'+order.mainorderid" style="margin-bottom:10px; background-color:#f2f2f2; color:#000"
        :title="order.pub"
        >
        {{order.docId}}
        Order Number {{order.mainorderid}} 
            <b-row :key="'buyeraddress'+order.mainorderid" style="">
                <b-col>
                    Address: <span style="font-weight:bold; color:#2e5189">{{order.billingaddress}}</span>
                </b-col>
            </b-row>
            <b-row :key="'orderdate'+order.mainorderid">
                <b-col>
                    Order Date: <span style="font-weight:bold; color:#2e5189">{{order.date}}</span>
                </b-col>
            </b-row>
            <b-row :key="'shippingterms'+order.mainorderid">
                <b-col>
                    Shipping Terms: <span style="font-weight:bold; color:#2e5189">{{order.selectedDeliveryOption}}</span>
                </b-col>
            </b-row>

            <!-- Show if deposit has been refunded -->
            <b-row v-if="order.kegDeposit>0" :key="'depositrefunded'+order.mainorderid">
                <b-col>
                    <div v-if="order.kegDepositRefunded==1">Keg deposit has been refunded</div>
                    <div v-else style="color:red">Keg Deposit Refund of ${{order.kegDeposit}} is due</div>
                </b-col>
            </b-row>

            <!-- Actions for this consumer -->
            <b-row :key="'orders'+order.mainorderid">
                
                <b-col>
                    <!-- Modal to issue refund -->
                    <b-modal no-fade size="l" :id="'modal-refund'+order.mainorderid" ok-only :title="'Refund ' + order.pub" ok-title="OK" 
                        :key="'therefundmodal'+order.mainorderid" :hide-footer="true">
                        <refund :order="order" :closeModal="closeModal" :isRefundingDeposit='isRefundingDeposit' />  
                    </b-modal>
                    <!-- Modal to mark order complete -->
                    <b-modal :id="'MarkComplete' + order.mainorderid" title="Mark Complete" 
                        ok-title ='Yes, Mark As Complete'  @ok="markComplete(order.mainorderid)" >
                        <p class="my-4">Mark this order as complete?</p>
                    </b-modal>
                    <!-- Modal to add tracking number -->
                    <b-modal :id="'tracking' + order.mainorderid" title="Add Tracking Info" 
                        ok-title ='Add Tracking Number'  @ok="addTrackingNumber($event,order.mainorderid )" >
                        <div class="mt-3" v-if="!shippingCarrier">Select a shipping method</div>
                        <div v-if="shippingError" class="errorclass">Missing shipping info</div>
                        <b-form-select v-model="shippingCarrier" :options="shippingCarrierOptions">
                        </b-form-select>
                        <b-form-input style="margin-top:10px" prepend="Tracking Number" id="input-4" v-model="trackingNumber" placeholder="Tracking Number"></b-form-input>
                        <br>
                    </b-modal>

                    <b-button-group style="margin-top:10px; margin-bottom:10px">
                        <!-- Send message button -->
                        <b-button v-b-modal="'sendmsgmodal' + order.mainorderid" v-b-tooltip.hover :title="'Message '+order.pub" 
                            class='btn btn-success action-buttons'><i><font-awesome-icon icon="comment" /></i>
                        </b-button>
                        <!-- Create PO -->
                        <b-button @click="showConsumerPO(order)"
                            class='btn btn-info action-buttons'>Create Purchase Order
                        </b-button>
                        <b-button v-if='order.status==0'  v-b-modal="'MarkComplete' + order.mainorderid"
                            class='btn btn-success action-buttons'>Mark Complete
                        </b-button>
                        <b-button v-b-modal="'tracking' + order.mainorderid"
                            class='btn btn-success action-buttons'>Add Tracking Info
                        </b-button>
                        <!-- Keg deposit refund -->
                        <b-button v-if="parseFloat(order.kegDeposit)>0&&order.kegDepositRefunded!=1" @click="issueKegRefund(order)"
                            class='btn btn-warning action-buttons'>Refund Keg Deposit
                        </b-button>
                        <b-button @click="issueRefund(order)"
                            class='btn btn-warning action-buttons'>Issue Other Refund
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <!-- Send message modal -->
            <b-modal :id="'sendmsgmodal' + order.mainorderid" title="Send a Message"  hide-footer :key="'sendmsgmodalkey' + order.mainorderid">
                <div class='col-12'>
                    <sendmessage  :receiverId="order.pubid" :receiverName="order.pub" :arrayDefaultMessages="arrayDefaultMessages"/>
                </div>
            </b-modal>

            <b-row :key="'messages'+order.mainorderid">
                <b-col>
                    <!-- Table of items in order -->
                    <table class="table table-bordered">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col"><small>Beverage</small></th>
                                <th scope="col"><small>Quantity</small></th>
                                <th scope="col"><small>Container</small></th>
                                <th scope="col"><small>Cost</small></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in order.cartItems" :key="item.id+item.suborderid">
                                <td>{{item.beerName}}</td>
                                <td>{{item.orderQuantity}}</td>
                                <td>{{item.size}}</td>
                                <td>$ {{item.itemsCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row :key="'itemscost'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Items Cost: $ {{order.totalItemsCost}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemstax'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Taxes: $ {{order.tax.toFixed(2)}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemsshipping'+order.mainorderid" v-if="order.shippingCost>0" style="text-align:right">
                <b-col>
                    <small>Shipping Cost: $ {{order.shippingCost}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemsdelivery'+order.mainorderid" v-if="order.deliveryCost>0" style="text-align:right">
                <b-col>
                    <small>Delivery Cost: $ {{order.deliveryCost}}</small>
                </b-col>
            </b-row>
            <b-row v-if="order.kegDeposit>0" :key="'kegdeposit'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Keg Deposit: $ {{order.kegDeposit}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemstotalcost'+order.mainorderid" style="text-align:right; color:green">
                <b-col>
                    Total Cost: $ {{parseFloat(order.totalCost).toFixed(2)}}
                </b-col>
            </b-row>
            <b-row :key="'itemsrefunds'+order.mainorderid" style="text-align:right; color:red">
                <b-col>
                    Refunds: $ {{getTotalRefunds(order).toFixed(2)}}
                </b-col>
            </b-row>
            <!-- Shipping Info -->
            <b-row :key="'shippingcarrier1'+order.mainorderid" v-if="order.shippingCarrier">
                <b-col>
                    Shipping Carrier: {{order.shippingCarrier}}
                </b-col>
                <b-col :key="'trackingnumber1'+order.mainorderid" v-if="order.trackingNumber">
                    Tracking Number: {{order.trackingNumber}}
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../../firebaseConfig'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')
    import Sendmessage from '../Sendmessage'
    import Refund from './Refund'

    export default {
        props: ['ordersArray'],
        components: {
            Sendmessage,
            Refund,
            },
        computed: {
            ...mapState(['userProfile', 'currentUser']),

        },

        data() {
            return {
                arrayDefaultMessages:[],
                trackingNumber:'',
                shippingCarrier:'',
                shippingCarrierOptions:['FedEx', 'GSO', 'UPS', 'US Postal Service', ' DHL'],
                shippingError:false,
                itemsCost:0,
                shippingCost:0,
                deliveryCost:0,
                taxes:0,
                totalCost:0,
                isRefundingDeposit:0,
                
            }
        },
        methods: {
            showConsumerPO(ordersObject){
                this.$router.push({ path: 'consumerpo', query: { ordersObject: ordersObject}})
            },
            //Mark an order complete
            markComplete(mainorderid){
                fb.consumerOrdersCollection.where('mainorderid', '==', mainorderid).get().then(docs => {
                docs.forEach(doc => {
                    var nowDate = new Date()
                    var lastUpdated = nowDate.getTime()
                    fb.consumerOrdersCollection.doc(doc.id).update({
                        status: 2,
                        shippedOn: new Date(),
                        lastUpdated:lastUpdated,
                    })
                    })
                }).catch(err => {
                console.log(err)
                })

            },

            //Calculate total refunds for each order
            getTotalRefunds(order){
                var totalRefunds = 0
                if ('refunds' in order){
                    for (var i=0; i<order.refunds.length; i ++){
                        var thisRefund = order.refunds[i]
                        if ('totalrefund' in thisRefund){
                            totalRefunds = totalRefunds + parseFloat(thisRefund.totalrefund)
                        } 
                    }
                }
                return totalRefunds
            },

            //Add tracking number
            addTrackingNumber(bvModalEvt, mainorderid){
                console.log("Adding tracking number for order")
                console.log("mainorderid = " + mainorderid)
                console.log("shippingCarrier = " + this.shippingCarrier)
                console.log("Tracking number = " + this.trackingNumber)
                this.shippingError = false

                //Default prevented so the modal doesn't close while we check for errors
                bvModalEvt.preventDefault()

                if(!this.shippingCarrier||!this.trackingNumber){
                    this.shippingError = true
                    return
                }

                //Remove modal. Next tick is required for some reason
                this.$nextTick(() => {
                    this.$bvModal.hide("tracking" + mainorderid)
                })

                fb.consumerOrdersCollection.where('mainorderid', '==', mainorderid).get().then(docs => {
                docs.forEach(doc => {
                    var nowDate = new Date()
                    var lastUpdated = nowDate.getTime()
                    console.log("Updating tracking number for docid = " + doc.id)
                    console.log("With tracking number = " + this.trackingNumber)
                    fb.consumerOrdersCollection.doc(doc.id).update({
                        shippingCarrier: this.shippingCarrier,
                        shippedOn: new Date(),
                        trackingNumber:this.trackingNumber,
                    }).then(docs => {
                        this.$bvToast.toast('Shipping info added', {
                            title: 'Shipping',
                            autoHideDelay: 2000,
                            appendToast: false,
                            solid:true,
                            variant:'success',
                        })
                        this.shippingCarrier=""
                        this.trackingNumber=""
                    })
                    
                    })
                }).catch(err => {
                console.log(err)
                })
                //this.shippingCarrier=""
                //this.trackingNumber=""
            },

            //Issue Keg refund
            issueKegRefund(order){
                console.log("Issuing refund")
                this.isRefundingDeposit = 1
                this.$bvModal.show("modal-refund" + order.mainorderid)

            },

            //Issue a refund
            issueRefund(order){
                console.log("Issuing refund")
                this.isRefundingDeposit = 0
                this.$bvModal.show("modal-refund" + order.mainorderid)

            },
            //Close refund modal
            closeModal(order){
                console.log("Closing modal for")
                this.$bvModal.hide("modal-refund" + order.mainorderid)
                
            },
        }
        
    }
</script>

<style>
.errorclass{
        color:red;
    }
</style>